import {EmailCaptureApiCaller} from "../../../EmailCaptureApiCaller";

export class MobileInlineComponent {
    private readonly component: HTMLElement | null;
    private readonly form: HTMLFormElement | null;
    private readonly errorElement: HTMLElement | null;
    private readonly emailInput: HTMLInputElement | null;
    private readonly successContainer: HTMLElement | null;

    constructor(private readonly apiCaller: EmailCaptureApiCaller) {
        this.component = document.querySelector('.js-serp-email-capture-mobile');
        this.form = document.querySelector('.js-serp-email-capture-mobile-form');
        this.errorElement = this.component?.querySelector('.js-serp-email-capture-mobile-email-feedback') as HTMLElement | null;
        this.emailInput = this.component?.querySelector('.js-serp-email-capture-mobile-email-input') as HTMLInputElement | null;
        this.successContainer = this.component?.querySelector('.js-serp-email-capture-mobile-success') as HTMLElement | null;
    }

    init(): void {
        if (!this.component) return;

        this.prefillEmail();
        this.registerFormSubmit();
    }

    isAvailable(): boolean {
        return this.component !== null;
    }

    hide(): void {
        if (this.component) {
            this.component.style.display = 'none';
        }
    }

    private prefillEmail(): void {
        const savedEmail = this.apiCaller.getEmailFromStorage();
        if (savedEmail && this.emailInput) {
            this.emailInput.value = savedEmail;
        }
    }

    private registerFormSubmit(): void {
        if (!this.form) return;

        this.form.addEventListener('submit', async (e: Event) => {
            e.preventDefault();

            const email = this.emailInput?.value?.trim();

            if (!email || !this.apiCaller.isValidEmail(email)) {
                this.showError();
                return;
            }

            this.hideError();

            const submitButton = this.form!.querySelector('.js-serp-email-capture-mobile-submit') as HTMLButtonElement;
            submitButton.disabled = true;

            try {
                const alertParams = this.apiCaller.getAlertParamsFromContainer(this.component, this.form);
                await this.apiCaller.submitAlert(email, alertParams);
                this.apiCaller.saveEmailToStorage(email);
                this.showSuccess();
            } catch (error) {
                this.showError();
                submitButton.disabled = false;
            }
        });
    }

    private showSuccess(): void {
        if (this.form) this.form.style.display = 'none';

        const description = this.component?.querySelector('.serp-email-capture-mobile__description') as HTMLElement | null;
        if (description) description.style.display = 'none';

        if (this.successContainer) this.successContainer.classList.add('visible');

        setTimeout(() => this.hide(), 3000);
    }

    private showError(): void {
        this.apiCaller.toggleError(this.errorElement, this.emailInput, true);
    }

    private hideError(): void {
        this.apiCaller.toggleError(this.errorElement, this.emailInput, false);
    }
}
